import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-872efc08"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "disabled", "name"]


export default /*#__PURE__*/_defineComponent({
  __name: 'MySmallCheckbox',
  props: {
    value: { type: Boolean },
    disabled: { type: Boolean },
    isDesktop: { type: Boolean },
    name: null
  },
  setup(__props: any) {

const props = __props as {
  value: boolean;
  disabled?: boolean;
  isDesktop: boolean;
  name: string;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "checkbox",
    checked: __props.value,
    class: _normalizeClass({ active: __props.value, disabled: __props.disabled, desktop: __props.isDesktop }),
    disabled: __props.disabled,
    name: __props.name
  }, null, 10, _hoisted_1))
}
}

})